import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';

export const accordion: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),

  '.responsiveTable__accordionElement__toggler': () => ({
    variant: 'buttons.outline',

    borderWidth: '1px',
    display: 'flex',
    gap: spacing(3),
    alignItems: 'stretch',
    width: '100%',
    px: 4,
    py: 3,
    '&:hover': {
      h3: {
        color: 'palette.primary.contrastText',
      },
    },

    '.accordionElement__toggler__checkbox': {
      flexShrink: 0,
      m: spacing(2),
    },

    '.accordionElement__toggler__button': {
      flexGrow: 100,
      display: 'flex',
      justifyContent: 'space-between',
      py: 2,
      pr: spacing(2),
      alignItems: 'center',

      '.accordionElement__toggler__label': {
        flexGrow: 100,
        m: spacing(0),
        textAlign: 'left',
        fontSize: 16,
      },

      '.accordionElement__toggler__expandIcon': {
        flexShrink: 0,
        svg: {
          width: '32px',
        },
      },
    },
  }),

  '.responsiveTable__accordionElement__content': {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      backgroundColor: 'palette.background.paper',
      transition: 'padding-bottom 300ms, padding-top 300ms',
      px: 5,
    },

    '&.rah-static--height-zero': {
      '& > div': { py: 0 },
    },

    '&.rah-static--height-auto, &.rah-animating--down': {
      '& > div': { py: 5 },
    },
    '.priority_container': { display: 'flex', alignItems: 'center' },
    '.priority': { display: 'flex' },
  },
};
